import script from "./NewClaimInputClipsNew.vue?vue&type=script&setup=true&lang=js"
export * from "./NewClaimInputClipsNew.vue?vue&type=script&setup=true&lang=js"

import "./NewClaimInputClipsNew.vue?vue&type=style&index=0&id=bc2cbf08&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc2cbf08"]])

export default __exports__